export const Dot = '·';
